import {
  Routes,
  Route,
  // Navigate
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Footer from "./components/footer";
// import HeaderNav from "./components/header";
import Main from "./components/home";
import { NewHeader } from "./components/newHeader";
import LocalLanguage from "./components/pages/local-language";
import ModelEvaluation from "./components/pages/model-evaluation";
import DataPipelineAndEvaluation from "./components/pages/data-pipeline-and-evaluation";
import ScalableIntegration from "./components/pages/scalable-integration";
import AIPlatform from "./components/pages/Ai-platform";
import Blogs from "./components/pages/blog";
import Events from "./components/pages/events";
import AboutUs from "./components/pages/about-us";
import SingleBlog from "./components/pages/blog/single-blog";
import { useScrollToTop } from "./utils/useScrollToTop";
import ContactUs from "./components/pages/contact-us";
import InfoSecurityPage from "./components/pages/InfoSecurityPage";
import LegalInfo from "./components/pages/LegalInfo";
import Chatbot from "./components/Chatbot";
import { Toaster } from "react-hot-toast";
import DemoModal from "./components/demoModal";
import DataAssistantPage from "./components/pages/data-assistant";
import AiInference from "./components/pages/Ai-Inference";
import WhatsAppChat from "./components/pages/Ngx-Whatsapp-Bot/WhatsAppChat";
import TraderbotLanding from "./components/pages/Ngx-Whatsapp-Bot/TraderbotLanding";
import TraderbotSignIn from "./components/pages/Ngx-Whatsapp-Bot/TraderbotSignIn";

function App() {
  useScrollToTop();

  const path = window.location.pathname;
  const hideChromeRoutes = ["/ngx-whatsapp-bot", "/traderbot-by-ngx", "/traderbot-by-ngx/sign-in"];
  const hideChrome = hideChromeRoutes.includes(path);

  return (
    <main className="App relative">
      {/* <HeaderNav /> */}
      {hideChrome ? null : <NewHeader />}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Routes>
        <Route exact path="/" element={<Main />} />
        <Route exact path="/local-language-llms" element={<LocalLanguage />} />
        <Route exact path="/model-evaluation" element={<ModelEvaluation />} />
        <Route
          exact
          path="/data-pipeline-and-evaluation"
          element={<DataPipelineAndEvaluation />}
        />
        <Route
          exact
          path="/scalable-integrations"
          element={<ScalableIntegration />}
        />
        <Route exact path="/ai-platform" element={<AIPlatform />} />
        <Route exact path="/data-assistant" element={<DataAssistantPage />} />
        <Route exact path="/ai-inference" element={<AiInference />} />
        <Route exact path="/blog" element={<Blogs />} />
        <Route exact path="/blog/:id" element={<SingleBlog />} />
        <Route exact path="/events" element={<Events />} />
        <Route exact path="/about-us" element={<AboutUs />} />
        <Route exact path="/contact" element={<ContactUs />} />
        <Route exact path="/isms-bcms" element={<InfoSecurityPage />} />
        <Route exact path="/legal-info" element={<LegalInfo />} />
        <Route exact path="/ngx-whatsapp-bot" element={<WhatsAppChat/>} />
        <Route exact path="/traderbot-by-ngx" element={<TraderbotLanding />} />
        <Route exact path="/traderbot-by-ngx/sign-in" element={<TraderbotSignIn />} />
      </Routes>

       <DemoModal />

      {hideChrome ? null : <Chatbot />}
      {/* <Footer /> */}

      <Toaster
        toastOptions={{
          style: {
            maxWidth: "700px",
            padding: "12px 16px",
            fontSize: "17px",
            fontWeight: "400",
          },
          error: {
            style: {
              color: "red",
            },
          },
          success: {
            style: {
              color: "green",
            },
          },
        }}
        position="top-center"
        reverseOrder={false}
      />

      <style jsx="true">
        {`
          .Toastify__toast-container {
            z-index: 9999999;
          }
        `}
      </style>
    </main>
  );
}

export default App;
